import { type ConfigComponentsProps } from '@sobrus-com/sobrus-design-system-v2';

export const dsConfig: ConfigComponentsProps = {
  fonts: {
    fontFamily:
      'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji,Segoe UI Emoji, Segoe UI Symbol',
  },
  solution: 'pharma',
};
